import { ITranslationEntry } from '../lang';

export const PL: ITranslationEntry = {
  translations: {
    notifications: 'Notyfikacje',
    markAllAsRead: 'Oznacz wszystkie jako przeczytane',
    poweredBy: 'Napędzany przez',
    settings: 'Ustawienia',
  },
  lang: 'pl',
};
